import { useState, useEffect, useCallback } from "react";
import { Grid } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import BackButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";
import TableCM from "components/shared/Table";
import GenarateHeadCell from "helper/generate-head-cell";
import useHttp from "hooks/use-http";
import { getOrderById } from "api/requests";
import LoadingCM from "components/shared/Loading";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import { StyledPaper } from "./OrderDetail.style";
import spliter from "helper/digit-spliter";

const headCells = GenarateHeadCell("factor");

export default function OrderDetail() {
  const params = useParams();
  const navigate = useNavigate();
  const { request, loading } = useHttp();
  const [products, setProducts] = useState([]);
  const [factorInfo, setFactorInfo] = useState({
    totalPrice: "",
    discount: "",
    totalCount: "",
    orderId: "",
    userName: "",
    date: "",
    phone: "",
    description: "",
  });

  const getOrder = useCallback(async () => {
    const res = await request({
      url: getOrderById,
      values: params.orderId,
    });

    if (res) {
      const transformedProducts = res.order_contents.map((items, index) => ({
        id: index,
        name: items.product_color?.product?.title,
        color: items.product_color?.title,
        count: items.quantity,
        price: items.product_color?.product?.price,
        priceMulty: items.total_price,
      }));

      setProducts(transformedProducts);
      setFactorInfo({
        payment_status:
          res.payment_status == "failed" ? (
            <span style={{ color: "red" }}>ناموفق</span>
          ) : (
            <span style={{ color: "green" }}>موفق</span>
          ),
        totalPrice: res.total_price,
        discount: res.discount == null ? "ندارد" : res.discount.amount,
        totalCount: res.products_quantity,
        orderId: res.order_number,
        description: res?.description,
        userName: res.user?.full_name,
        date: res.created_at?.jdate,
        phone: res.user?.phone_number,
        address: res.user_address?.address,
        state: res.user_address?.state,
        city: res.user_address?.city,
        postal_code: res.user_address?.postal_code,
      });
    }
  }, [request]);

  useEffect(() => {
    getOrder();
  }, [getOrder]);

  return (
    <DrawerCM title="فاکتور">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container>
          <Grid item mt={3}>
            <BackButton />
          </Grid>

          <Grid item xs={12} my={2} mt={4}>
            <TableCM
              rows={products}
              headCells={headCells}
              // factor
              // factorInfo={factorInfo}
              page={1}
            />
          </Grid>
          <Grid item xs={12} my={2} mt={4}>
            <StyledPaper>
              <div>
                <span>وضعیت سفارش : </span>
                <span>{factorInfo.payment_status}</span>
              </div>
              <Divider />
              <div>
                <span>تاریخ : </span>
                <span>{factorInfo.date}</span>
              </div>
              <Divider />
              <div>
                <span>نام : </span>
                <span>{factorInfo.userName}</span>
              </div>
              <Divider />
              <div>
                <span>شماره تماس : </span>
                <span>{factorInfo.phone}</span>
              </div>
              <Divider />
              <div>
                <span>شماره پیگیری : </span>
                <span>{factorInfo.orderId}</span>
              </div>
              <Divider />
              <div>
                <span>استان : </span>
                <span>{factorInfo.state}</span>
              </div>
              <Divider />
              <div>
                <span>شهر : </span>
                <span>{factorInfo.city}</span>
              </div>
              <Divider />
              <div>
                <span>کدپستی : </span>
                <span>{factorInfo.postal_code}</span>
              </div>
              <Divider />
              <div>
                <span>آدرس : </span>
                <span>{factorInfo.address}</span>
              </div>
              <Divider />
              <div>
                <span>تعداد : </span>
                <span>{products.length}</span>
              </div>
              <Divider />
              <div>
                <span>تخفیف : </span>
                <span>{factorInfo.discount}</span>
              </div>
              <Divider />
              <div>
                <span>توضیحات : </span>
                <span>{factorInfo.description}</span>
              </div>
              <Divider />
              <div>
                <span>جمع کل : </span>
                <span>{spliter(factorInfo.totalPrice)} تومان</span>
              </div>
              <Divider />
            </StyledPaper>
          </Grid>
        </Grid>
      )}
    </DrawerCM>
  );
}
